module.exports = __webpack_public_path__ + "img/cursor-sm.1ec153d7.png";